module.exports = __webpack_public_path__ + "static/media/6.dcd0b0a1.jpg";